import "esbuild-css-modules-plugin-ns-css:src/js/components/ResultsSummary/ResultsSummary.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/ResultsSummary/ResultsSummary.module.css:injector.js";
export default new Proxy({
  "detailedSummaryContainer": "ResultsSummary-module__detailedSummaryContainer_54JIbW__1100",
  "detailedSummaryContainerClosed": "ResultsSummary-module__detailedSummaryContainerClosed_54JIbW__1100",
  "detailedSummaryContainerOpen": "ResultsSummary-module__detailedSummaryContainerOpen_54JIbW__1100",
  "detailedSummaryHeading": "ResultsSummary-module__detailedSummaryHeading_54JIbW__1100",
  "detailedSummaryToggle": "ResultsSummary-module__detailedSummaryToggle_54JIbW__1100",
  "expandBtnChevron": "ResultsSummary-module__expandBtnChevron_54JIbW__1100",
  "expandBtnChevronOpen": "ResultsSummary-module__expandBtnChevronOpen_54JIbW__1100",
  "expandBtnText": "ResultsSummary-module__expandBtnText_54JIbW__1100",
  "summaryStatement": "ResultsSummary-module__summaryStatement_54JIbW__1100",
  "ul": "ResultsSummary-module__ul_54JIbW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      